import { type CSSObject } from '@emotion/react';
import { type Theme } from '../../../../theme';
import { type ButtonSize } from '../button/button.types';

type UseButtonWithDropdownStyleReturn = Record<
  'overlay' | 'fullButton' | 'container' | 'textContainer' | 'iconContainer',
  CSSObject
>;

export const useButtonWithDropdownStyles = ({
  theme,
  fullWidth,
  size,
}: {
  theme: Theme;
  size: ButtonSize;
  fullWidth: boolean;
}): UseButtonWithDropdownStyleReturn => {
  return {
    overlay: {
      paddingRight: size === 'xsmall' ? theme.spacing(1) : theme.spacing(2),

      '&:before': {
        content: '""',
        position: 'absolute',
        inset: 0,
      },
    },
    fullButton: {
      width: '100%',
    },
    container: {
      ...(fullWidth
        ? {
            display: 'grid',
            gridTemplateRows: '1fr',
            gridTemplateColumns: '1fr',
            width: '100%',
            gap: 'inherit',
          }
        : {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 'inherit',
            flexGrow: 1,
          }),
    },
    textContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gridColumn: 1,
      gridRow: 1,
      gap: 'inherit',
      flexGrow: 1,
    },
    iconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gridColumn: 1,
      gridRow: 1,
      gap: 'inherit',
    },
  };
};
